export default __webpack_public_path__ + "static/media/BGLayer2b.5d01a5ad.png";